import { ControllerBase, defineViewModel } from '@/utils/bizify';

type PageData = {
  // 激活搜索参数
  savedParamsActive: boolean;
  // 账户切换提示弹窗
  accountChangedModalVisible: boolean;
  // berachain modal
  showBeraChainModal: boolean;
};
export class GlobalPageCtrl extends ControllerBase<PageData> {
  protected $data(): PageData {
    return {
      savedParamsActive: false,
      accountChangedModalVisible: false,
      showBeraChainModal: false
    };
  }

  setSavedParamsActive = (savedParamsActive: boolean): void => {
    this.state.savedParamsActive = savedParamsActive;
  };

  toggleAccountChangedModal = (accountChangedModalVisible: boolean): void => {
    this.state.accountChangedModalVisible = accountChangedModalVisible;
  };

  toggleBeraChainModal = (showBeraChainModal: boolean): void => {
    this.state.showBeraChainModal = showBeraChainModal;
  };
}

export const globalVm = defineViewModel(GlobalPageCtrl);
